module.exports = __webpack_public_path__ + "img/LenoreTawney-MagdalenaAbakanowicz-DEborahValoma-JiroYonezawa-MarietteRousseau-Vermette-DebraSachs.2fd2903a.jpg";